import FadeIn from '../components/FadeIn';
import { PRODUCTS_MAIN, PRODUCTS_OTHER, WA_URL } from '../data/constants';

export default function Productos() {
  return (
    <section className="sec sec-white" style={{ paddingTop: 108 }}>
      <FadeIn>
        <div className="sec-tag">Comercialización</div>
        <h2 className="sec-title">Nuestros productos</h2>
        <p className="sec-sub">
          Equipos, repuestos y accesorios especializados para estaciones de servicio y la industria del petróleo.
        </p>
      </FadeIn>

      <div className="prod-grid">
        {PRODUCTS_MAIN.map((p, i) => (
          <FadeIn key={p.name} delay={i * 40}>
            <div className="prod-card">
              <div className="prod-name">{p.name}</div>
              <div className="prod-cat">{p.cat}</div>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={240}>
        <div style={{ marginTop: 48 }}>
          <div className="sec-tag" style={{ marginBottom: 14 }}>Otros productos que ofrecemos</div>
          <div className="other-list">
            {PRODUCTS_OTHER.map((p) => (
              <div key={p} className="other-item">{p}</div>
            ))}
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={320}>
        <div style={{ background: '#FFF8F2', border: '1px solid #F0DDD0', borderLeft: '3px solid #D4600A', padding: '32px 36px', marginTop: 44, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20 }}>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.2em', textTransform: 'uppercase', color: '#D4600A', marginBottom: 8 }}>
              ¿Necesitas un repuesto?
            </div>
            <h3 style={{ fontFamily: "'Merriweather',serif", fontSize: 22, fontWeight: 900, color: '#1C2B3A' }}>
              Consultanos disponibilidad
            </h3>
          </div>
          <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="btn btn-fuel btn-sm">
            Consultar ↗
          </a>
        </div>
      </FadeIn>
    </section>
  );
}
